
import React from 'react';

interface LogoSliderProps {
  logos: string[];
}

const LogoSlider = ({ logos }: LogoSliderProps) => {
  return (
    <section className="py-16 bg-white overflow-hidden">
      <div className="container mx-auto px-6">
        <h2 className="text-center text-2xl font-light text-navy-900 mb-12">
          Quelques créations <span className="font-semibold text-blue-600">récentes</span>
        </h2>
        
        <div className="relative">
          <div className="flex animate-[scroll_30s_linear_infinite] gap-12">
            {[...logos, ...logos].map((logo, index) => (
              <div 
                key={index} 
                className="flex-shrink-0 bg-white shadow-lg p-8 w-48 h-32 flex items-center justify-center hover:shadow-xl transition-shadow duration-300 cursor-pointer select-none"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              >
                <img 
                  src={logo} 
                  alt={`Logo ${index + 1}`} 
                  className="max-w-full max-h-full object-contain pointer-events-none select-none" 
                  draggable={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogoSlider;
